export default __webpack_public_path__ + "static/media/saas.ff888c43.webp";